import React from "react";

const FigmaIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_964)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.9774 20C19.9774 16.3181 22.972 13.3333 26.6662 13.3333C30.3602 13.3333 33.3549 16.3181 33.3549 20C33.3549 23.6819 30.3602 26.6666 26.6662 26.6666C22.972 26.6666 19.9774 23.6819 19.9774 20Z",
  fill: "#1ABCFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.59998 33.3333C6.59998 29.6515 9.59462 26.6666 13.2887 26.6666H19.9775V33.3333C19.9775 37.0152 16.9828 40 13.2887 40C9.59462 40 6.59998 37.0152 6.59998 33.3333Z",
  fill: "#0ACF83"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9774 0V13.3333H26.6662C30.3603 13.3333 33.3549 10.3486 33.3549 6.66666C33.3549 2.98477 30.3603 0 26.6662 0H19.9774Z",
  fill: "#FF7262"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.59998 6.66667C6.59998 10.3486 9.59462 13.3333 13.2887 13.3333H19.9775V0H13.2887C9.59462 0 6.59998 2.98477 6.59998 6.66667Z",
  fill: "#F24E1E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.59998 20C6.59998 23.6819 9.59462 26.6666 13.2887 26.6666H19.9775V13.3333H13.2887C9.59462 13.3333 6.59998 16.3181 6.59998 20Z",
  fill: "#A259FF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_964"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FigmaIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;